<template>
  <div v-loading="loading">
    <!-- <flow-cate :all="true" :flowCates="cates" @selectCate="switchTypeId"></flow-cate> -->
    <flow-list :caseId="caseId" :path="path"></flow-list>
  </div>
</template>

<script>
  import flowCate from '../common/flowCate.vue'
  import flowList from '../common/flowList.vue'
  import http from '../../../assets/js/http'
  import flowCommon from '../mixins/flowCommon'

  export default {
    name: 'mystart',
    data() {
      return {
        caseId: 4       // 我的发起
      }
    },
    props: {
    },
    created() {
      this.path = this.$route.path
      // this.getFlowCates()
    },
    components: {
      flowCate,
      flowList
    },
    mixins: [http, flowCommon]
  }
</script>


// WEBPACK FOOTER //
// mystart.vue?313917fc